import { Grid } from '@mui/material';
import React from 'react';

const HomeBanners = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <h1>Banners</h1>
      </Grid>
    </Grid>
  );
};

export default HomeBanners;
